module.exports = __webpack_public_path__ + "media/images/covid/icons/thermographS-64162ee3e8da1275a48bca825735dd3b.png";